import CountryAutocomplete from "./country-autocomplete";

enum RecognisonStatus {
    Non_Recognised = 0,
    Recognised = 1,
    Recognised_Experienced_Driver = 2,
    Custom = 3
}
export default class OverseasLicenceConverter {
    widgetContainer: HTMLDivElement;
    resultsContainer: HTMLDivElement;

    countryAutocomplete: CountryAutocomplete;
    licenceConversionList: OverseasLicenceConversionItem[];

    constructor(widgetId: string, searchFormId: string, licenveConversionList: OverseasLicenceConversionItem[]) {
        this.widgetContainer = document.getElementById(widgetId) as HTMLDivElement;
        this.licenceConversionList = licenveConversionList;
        this.Init();
        this.countryAutocomplete = new CountryAutocomplete(searchFormId, this.licenceConversionList, this.displayStatus.bind(this)); // add callback here
    }

    Init() {
        this.setElements();
    }

    private setElements() {
        this.resultsContainer = this.widgetContainer.querySelector(".results-container");

    }
    displayStatus(selectedCountry?: OverseasLicenceConversionItem) {
        const noresultsText = this.resultsContainer.querySelector(".no-results");
        const allResultsTemplates = this.resultsContainer.querySelectorAll(".results-template");

        allResultsTemplates.forEach(template => !template.classList.contains("d-none") && template.classList.add("d-none"));
        noresultsText.classList.remove("d-none");
        if (!selectedCountry)
            return;
        let resultsTemplate: HTMLElement;
        let countryFlagElement: HTMLImageElement;
        let countryLabelElement: HTMLElement;
        let countryNameElement: HTMLElement;
        let conversionInfo: HTMLElement;
        switch (selectedCountry.recognitionStatus) {
            case Number(RecognisonStatus.Recognised):
                resultsTemplate = this.resultsContainer.querySelector("#recognised") as HTMLElement;
                break;
            case Number(RecognisonStatus.Recognised_Experienced_Driver):
                resultsTemplate = this.resultsContainer.querySelector("#exp-recognised") as HTMLElement;
                break;
            case Number(RecognisonStatus.Non_Recognised):
                resultsTemplate = this.resultsContainer.querySelector("#non-recognised") as HTMLElement;
                break;
            case Number(RecognisonStatus.Custom):
                resultsTemplate = this.resultsContainer.querySelector("#custom") as HTMLElement;
                conversionInfo = resultsTemplate.querySelector(".conversion-info");
                conversionInfo.innerHTML = `${selectedCountry.countryDisplayName} ${selectedCountry.customStatusText}`;
                break;
        }
        countryFlagElement = resultsTemplate.querySelector('img') as HTMLImageElement;
        countryLabelElement = resultsTemplate.querySelector('h3.country');
        countryNameElement = resultsTemplate.querySelector('.country-name');
        if (countryFlagElement != null
            && countryLabelElement != null) {
            countryFlagElement.src = selectedCountry.countryFlag;
            countryLabelElement.innerText = selectedCountry.countryDisplayName;
        }
        if (countryNameElement != null)
            countryNameElement.innerText = selectedCountry.countryDisplayName;
        resultsTemplate.classList.remove('d-none');
        noresultsText.classList.add("d-none");
    }


}